import React, { useEffect } from 'react'
import { RouteComponentProps } from '@reach/router'
import { PanelContent } from '../../../components/panel-content'
import { Button } from '../../../components/button'
import { useStateValue } from '../../../components/state'
import { MapFact } from '../../../components/map-fact'
import { useDelayedBoolean } from '../../../hooks/use-delayed-boolean'
import { TextLink } from '../../../components/text-link'
import { Video } from '../../../components/video'

export const Dams: React.FC<RouteComponentProps> = () => {
  const [, dispatch] = useStateValue()

  // Filter map pins to dams
  useEffect(() => {
    dispatch({
      type: 'setActiveMarkerType',
      payload: { activeMarkerType: 'dam' }
    })
  }, [dispatch])

  const factVisible = useDelayedBoolean({ delay: 500 })

  return (
    <PanelContent>
      <h1>Dams</h1>
      <p>
        Rainfall that’s run off the land into streams eventually ends up in{' '}
        <TextLink href='https://www.watercorporation.com.au/Our-water/Rainfall-and-dams/Dam-levels'>
          our dams
        </TextLink>
        . In the past, Perth relied heavily on our dams as a water source. But
        now with climate change, we’re getting less rain and dam water is
        becoming a smaller portion of our water supply.
      </p>
      <p>
        Instead, our dams have a bigger role to play in water storage. We’re
        transferring water produced by{' '}
        <TextLink href='https://www.watercorporation.com.au/Our-water/Desalination'>
          desalination
        </TextLink>{' '}
        and{' '}
        <TextLink href='https://www.watercorporation.com.au/Our-water/Groundwater'>
          groundwater
        </TextLink>{' '}
        into our dams to ensure year-round water supply.
      </p>
      <Video videoId='OqMAaD61Tx0' />
      <MapFact
        aboveValue='Steamflow into Perth dams has reduced by over 85% since the 1960s.'
        visible={factVisible}
        position='top-left'
      />
      <Button href='/why'>Why we can't rely on dams</Button>
    </PanelContent>
  )
}
